import { useParams } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import React, { Fragment, useEffect } from "react";
import { fetchFolders } from "../../../store/action-creators/folders";
import { fetchOrders } from "../../../store/action-creators/orders";
import { find, isEmpty } from "lodash";
import { TRootState } from "../../../store/reducers/RootReducer";
import { TFoldersState } from "../../../store/reducers/folders";
import { TOrdersSubState } from "../../../store/reducers/orders";
import AddFolderControl from "../AddFolderControl";
import { Card, Table } from "react-bootstrap";
import Link from "../../Navigation/Links/Link";
import { paths } from "../../../router";
import FolderList from "../FolderList";
import OrderList, { IFolder } from "../OrderList";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import AddOrderButton from "../../AddOrderButton";
import LoadingIndicator from "../../Feedback/LoadingIndicator";
import FolderBreadcrumbs from "../FolderBreadcrumbs";

dayjs.extend(relativeTime);

interface IRouteParams {
  folderId?: string
}

const Browser = () => {
  const params = useParams<IRouteParams>();
  const dispatch = useDispatch();
  const { folderId } = params;
  const id = (folderId && parseInt(folderId, 10)) || null;

  useEffect(() => {
    dispatch(fetchFolders())
  }, []);

  useEffect(() => {
    dispatch(fetchOrders({ folder_id: id }));
  }, [id]);

  const foldersState = useSelector<TRootState, TFoldersState>(state => state.folders, shallowEqual);
  const ordersState = useSelector<TRootState, TOrdersSubState | undefined>(state => state.orders[id || -1], shallowEqual);

  if (!ordersState) {
    return <LoadingIndicator />;
  }

  if (foldersState.error || ordersState.error) {
    return <div>Sorry! It seems data is currently unavailable.</div>;
  }

  if (!foldersState.loadedAt) {
    return <LoadingIndicator />;
  }

  const folders = foldersState.data;
  const orders = ordersState.data;

  const currentFolder = (id && find(folders, { id: id })) || null;

  if (folderId && !currentFolder) {
    return <div>Sorry! It seems folder could not be found.</div>
  }

  const foldersInFolder = folders.filter(folder => folder.parent_id === id);
  const availableFolders: Array<IFolder> = folders.filter(folder => folder.id !== id);
  if (id !== null) {
    availableFolders.unshift({
      id: null,
      name: 'Root folder'
    });
  }

  return (
    <Fragment>
      <div className="browser-toolbar">
        <FolderBreadcrumbs currentFolder={currentFolder} />

        <div className="browser-actions">
          <AddOrderButton />

          <AddFolderControl />
        </div>
      </div>

      <Card className="browser">
        <Table striped bordered={false} hover>
          <tbody>
            {
              currentFolder &&
              <tr>
                <td className="folder-type">
                  <Link
                    to={currentFolder.parent_id ? paths.ordersByFolder(currentFolder.parent_id) : paths.orders}
                  >
                    . .
                  </Link>
                </td>
                <td colSpan={100}></td>
              </tr>
            }

            <FolderList folders={foldersInFolder} />

            {
              ordersState.loading ? (
                <tr>
                  <td colSpan={100} style={{ textAlign: 'center' }}>
                    <LoadingIndicator />
                  </td>
                </tr>
              ) : <OrderList orders={orders} availableFolders={availableFolders} currentFolderId={id} />
            }

            {
              isEmpty(foldersInFolder) && isEmpty(orders) && ordersState.loadedAt &&
              <tr>
                <td colSpan={100} style={{ textAlign: 'center' }}>You have no orders.</td>
              </tr>
            }
          </tbody>
        </Table>
      </Card>
    </Fragment>
  );
};

export default Browser;
